export enum PublicLocalStorageKey {
	LOCAL_ACTORS = 'localActors',
	LATEST_ACTOR_USERS = 'latestActorMailAddresses',
	ACTOR_MODEL = 'actorModel',
	JSON_WEB_TOKEN = 'jsonWebToken'
}
